import { ModalCloseResult } from './modal-close-result';
import { ModalData } from './modal-data';

export class ActiveModal<D extends ModalData = ModalData, R = unknown> {
  constructor(
    private identifier: symbol,
    private data: D,
    private closeCallback: (result?: ModalCloseResult<R>) => void,
    private dismissCallback: (result?: ModalCloseResult<any>) => void,
    private switchToCallback: (componentIdentifier: symbol, data: ModalData) => void,
    isClosable: boolean = true
  ) {
    this.isClosable = isClosable;
  }

  /**
   * Whether the modal should close automatically when the user presses ESC or a navigation occurs
   */
  isClosable: boolean;

  /**
   * Switches to another modal with new configuration data.
   */
  switchTo(componentIdentifier: symbol, data: ModalData = null): void {
    this.switchToCallback(componentIdentifier, data);
  }

  /**
   * Successfully closes the modal with an optional `result` value.
   */
  close(result?: ModalCloseResult<R>): void {
    this.closeCallback(result);
  }

  /**
   * Unsuccessfully dismisses the modal with an optional `result` value.
   */
  dismiss(result?: ModalCloseResult<any>): void {
    this.dismissCallback(result);
  }

  /**
   * identifier of the active modal.
   */
  getIdentifier(): symbol {
    return this.identifier;
  }

  /**
   * configuration data for the active modal.
   */
  getData(): D {
    return this.data;
  }
}
